export function isDevEnv() {
  return ['development'].includes(process.env.NODE_ENV);
}
